module.exports = "/_next/static/images/b15ab9e4b23ff52458a6bd6337322716-cartao-proximo-ao-olho-md@2x.jpg.webp";